module.exports = __webpack_public_path__ + "media/images/docflix-logo-cdded01d90fcbb2256e8b06b4f32c84f.svg";